module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-option-mag-734afbf303e8f88701a34752810b0322.jpg";